<button
  mat-icon-button
  [matMenuTriggerFor]="menu"
  (menuOpened)="markNotificationsAsOpened()">
  <mat-icon>notifications</mat-icon>
  @if (unopenedCount && unopenedCount > 0) {
    <span class="badge">{{ unopenedCount }}</span>
  }
</button>

<mat-menu #menu="matMenu">
  @if (memberID) {
    <mat-toolbar>
      <b>Notificaties</b>
      <span fxFlex></span>
      <button
        mat-icon-button
        [routerLink]="'/members/settings'">
        <mat-icon>settings</mat-icon>
      </button>
    </mat-toolbar>
  }
  <div class="notifications">
    @if (!notifications) {
      <app-spinner></app-spinner>
    }
    @if (notifications && notifications.length === 0) {
      <div class="empty">
        <span class="title-with-icon">
          <mat-icon>check</mat-icon>
          Je hebt nog geen notificaties ontvangen.
        </span>
      </div>
    }
    @for (notification of notifications; track notification) {
      <div
        matRipple
        class="notification"
        [ngClass]="{ 'with-action': !!notification.action, 'opened': !!notification.opened }"
        [routerLink]="notification.action ? [notification.action] : []">
        <b>{{ notification.title }}</b>
        <p>{{ notification.message }}</p>
        <small>{{ notification.dateTime | amTimeAgo }}</small>
      </div>
    }
  </div>
</mat-menu>